"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FileInputContext", {
  enumerable: true,
  get: function get() {
    return _context5.default;
  }
});
Object.defineProperty(exports, "withFileInputContext", {
  enumerable: true,
  get: function get() {
    return _withFileInputContext.default;
  }
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../../lib");

var _constants = require("../../constants");

var _common = require("../../common");

require("./styles.css");

var _context5 = _interopRequireDefault(require("./context"));

var _DropZone = _interopRequireDefault(require("./DropZone"));

var _withFileInputContext = _interopRequireDefault(require("./withFileInputContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FileInput =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FileInput, _PureComponent);

  function FileInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FileInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FileInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isFileDialogActive: false,
      active: false,
      files: [],
      accepted: [],
      rejected: []
    });

    _defineProperty(_assertThisInitialized(_this), "wrapperRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "innerRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "dropZones", []);

    _defineProperty(_assertThisInitialized(_this), "timer", null);

    _defineProperty(_assertThisInitialized(_this), "onDocumentDragOver", function (e) {
      (0, _lib.callEventMethods)(e, 'preventDefault');
    });

    _defineProperty(_assertThisInitialized(_this), "onDocumentDrop", function (e) {
      var current = _this.wrapperRef.current;

      if (e && current && current.contains(e.target)) {
        // if we intercepted an event for our instance,
        // let it propagate down to the instance's onDrop handler
        return;
      }

      (0, _lib.callEventMethods)(e, 'preventDefault');
      _this.dropZones = [];
    });

    _defineProperty(_assertThisInitialized(_this), "onFileDialogCancel", function () {
      // timeout will not recognize context of this method
      // execute the timeout only if the FileDialog is opened in the browser
      var isFileDialogActive = _this.state.isFileDialogActive;

      if (isFileDialogActive) {
        _this.clearTimer();

        _this.timer = setTimeout(function () {
          var callOnCancel = false;
          var current = _this.innerRef.current;

          if (current) {
            // Returns an object as FileList
            var files = current.files;
            callOnCancel = !files.length;
          }

          _this.setState({
            isFileDialogActive: false
          }, function () {
            if (callOnCancel) {
              var onFileDialogCancel = _this.props.onFileDialogCancel;

              if (onFileDialogCancel) {
                onFileDialogCancel();
              }
            }
          });
        }, 300);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearTimer", function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var propNames = ['fluid'];
      var names = [FileInput.className];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "open", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation');
      var disabled = _this.props.disabled;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      } // Take off isFileDialogActive to fix the issue of
      // firefox only cannot open dialog after first time


      _this.setState({
        isFileDialogActive: true
      }, function () {
        var current = _this.innerRef.current;

        if (current) {
          current.value = null;
          current.click();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (e) {
      _this.open(e);

      var onClick = _this.props.onClick;

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDragStart", function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onDragStart = _this$props.onDragStart;
      (0, _lib.callEventMethods)(e, 'persist');

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (onDragStart) {
        onDragStart(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDragEnter", function (e) {
      var disabled = _this.props.disabled;
      (0, _lib.callEventMethods)(e, 'persist', 'preventDefault');

      if (disabled) {
        return;
      } // Count the dropzone and any children that are entered.


      if (e && _this.dropZones.indexOf(e.target) === -1) {
        _this.dropZones.push(e.target);
      }

      var active = _this.state.active;

      if (!active) {
        _this.setState({
          active: true
        }, function () {
          var onDragEnter = _this.props.onDragEnter;

          if (onDragEnter) {
            onDragEnter(e);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDragOver", function (e) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          onDragOver = _this$props2.onDragOver;
      (0, _lib.callEventMethods)(e, 'persist', 'preventDefault', 'stopPropagation');

      if (disabled) {
        return;
      }

      try {
        e.dataTransfer.dropEffect = 'copy'; // Fix the firefox issue of upload then can't drag and drop from the folder on the first time

        var isFileDialogActive = _this.state.isFileDialogActive;

        if (!isFileDialogActive) {
          _this.setState({
            isFileDialogActive: true
          });
        }
      } catch (err) {// continue regardless of error
      }

      if (onDragOver) {
        onDragOver(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDragLeave", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'preventDefault');
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      } // Only deactivate once the dropzone and all children have been left.


      var current = _this.wrapperRef.current;
      _this.dropZones = _this.dropZones.filter(function (el) {
        return el !== e.target && current.contains(el);
      });

      if ((0, _lib.numberHasLength)(_this.dropZones.length)) {
        return;
      }

      var active = _this.state.active;

      if (active) {
        _this.setState({
          active: false
        }, function () {
          var onDragLeave = _this.props.onDragLeave;

          if (onDragLeave) {
            onDragLeave(e);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDrop", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'preventDefault');
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      _this.dropZones = [];

      _this.handleOnChange(e);

      var onDrop = _this.props.onDrop;

      if (onDrop) {
        onDrop(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "generateFileErrors", function (file) {
      var accepted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var errors = [];
      var _this$props3 = _this.props,
          accept = _this$props3.accept,
          maxSize = _this$props3.maxSize,
          minSize = _this$props3.minSize,
          multiple = _this$props3.multiple;

      if (!(0, _lib.fileAccepted)(file, accept)) {
        var types = (0, _lib.arrayHasItems)(accept) ? accept.reduce(function (result, current, idx, arr) {
          var output = result;
          if (idx === 0) return output;

          if (idx !== arr.length - 1) {
            output = "".concat(output, ", ").concat(current);
          } else {
            output = "".concat(output, " or ").concat(current);
          }

          return output;
        }, accept[0]) : accept;
        errors.push("Invalid file type: please upload ".concat(types, " only"));
      }

      if (!(0, _lib.fileMatchMaxSize)(file, maxSize)) {
        errors.push("Invalid file size: file must not larger than ".concat((0, _lib.readableBytes)(maxSize)));
      }

      if (!(0, _lib.fileMatchMinSize)(file, minSize)) {
        errors.push("Invalid file size: file must not smaller than ".concat((0, _lib.readableBytes)(minSize)));
      }

      if (!(multiple || !multiple && !accepted.length)) {
        errors.push('Additional files rejected for non multiple input');
      }

      return errors;
    });

    _defineProperty(_assertThisInitialized(_this), "generateFileInfo",
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(file) {
        var blob, name, ext, size, info, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                blob = _this.props.blob;
                name = file.name;
                ext = (0, _lib.getFileExtensionFromString)(file.name);
                size = (0, _lib.readableBytes)(file.size); // general info

                info = {
                  name: name,
                  extension: ext,
                  size: size
                }; // blob read file

                if (!(0, _lib.arrayHasItems)(blob)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return (0, _lib.asyncForEach)(blob,
                /*#__PURE__*/
                function () {
                  var _ref2 = _asyncToGenerator(
                  /*#__PURE__*/
                  regeneratorRuntime.mark(function _callee(b) {
                    var result;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return FileInput.readFile(file, b);

                          case 2:
                            result = _context.sent;
                            info.blob = _objectSpread({}, info.blob, _defineProperty({}, b, result));

                          case 4:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 8:
                _context2.next = 15;
                break;

              case 10:
                if (!blob) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 13;
                return FileInput.readFile(file, blob);

              case 13:
                result = _context2.sent;
                info.blob = _defineProperty({}, blob, result);

              case 15:
                return _context2.abrupt("return", info);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleOnChange",
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(e) {
        var disabled, state, accepted, rejected, updatedFiles, files;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                (0, _lib.callEventMethods)(e, 'persist');
                disabled = _this.props.disabled;

                if (!disabled) {
                  _context4.next = 5;
                  break;
                }

                (0, _lib.callEventMethods)(e, 'preventDefault');
                return _context4.abrupt("return");

              case 5:
                state = {
                  active: false
                };
                accepted = [];
                rejected = [];
                updatedFiles = [];
                _context4.next = 11;
                return (0, _lib.getDataTransferFiles)(e);

              case 11:
                files = _context4.sent;

                if (!(0, _lib.arrayHasItems)(files)) {
                  _context4.next = 18;
                  break;
                }

                _context4.next = 15;
                return (0, _lib.asyncForEach)(files,
                /*#__PURE__*/
                function () {
                  var _ref4 = _asyncToGenerator(
                  /*#__PURE__*/
                  regeneratorRuntime.mark(function _callee3(file) {
                    var errors, info;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            errors = _this.generateFileErrors(file, accepted);
                            _context3.next = 3;
                            return _this.generateFileInfo(file);

                          case 3:
                            info = _context3.sent;

                            if ((0, _lib.arrayHasItems)(errors)) {
                              rejected.push({
                                file: file,
                                errors: errors,
                                info: info
                              });
                            } else {
                              accepted.push({
                                file: file,
                                errors: errors,
                                info: info
                              });
                            }

                            updatedFiles.push({
                              file: file,
                              errors: errors,
                              info: info
                            });

                          case 6:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x4) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 15:
                state.files = updatedFiles;
                state.accepted = accepted;
                state.rejected = rejected;

              case 18:
                _this.setState(state, function () {
                  var isFileDialogActive = _this.state.isFileDialogActive;

                  if (!isFileDialogActive) {
                    // if drop files
                    var current = _this.innerRef.current;

                    if (current) {
                      // clear input value
                      current.value = null;
                    }
                  }

                  if ((0, _lib.arrayHasItems)(rejected) && rejected.some(function (r) {
                    return (0, _lib.arrayHasItems)(r.errors);
                  })) {
                    var _this$props4 = _this.props,
                        onError = _this$props4.onError,
                        _name = _this$props4.name;

                    if (onError) {
                      onError(e, {
                        name: _name,
                        files: updatedFiles,
                        accepted: accepted,
                        rejected: rejected
                      });
                    }
                  }

                  var _this$props5 = _this.props,
                      onChange = _this$props5.onChange,
                      name = _this$props5.name;

                  if (onChange) {
                    onChange(e, {
                      name: name,
                      files: updatedFiles,
                      accepted: accepted,
                      rejected: rejected
                    });
                  }
                });

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());

    return _this;
  }

  _createClass(FileInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('dragover', this.onDocumentDragOver, false);
      document.addEventListener('drop', this.onDocumentDrop, false);
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimer();
      document.removeEventListener('dragover', this.onDocumentDragOver, false);
      document.removeEventListener('drop', this.onDocumentDrop, false);
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: "render",
    // render
    value: function render() {
      var _this$props6 = this.props,
          as = _this$props6.as,
          name = _this$props6.name,
          className = _this$props6.className,
          wrapperRef = _this$props6.wrapperRef,
          innerRef = _this$props6.innerRef,
          accept = _this$props6.accept,
          multiple = _this$props6.multiple,
          minSize = _this$props6.minSize,
          maxSize = _this$props6.maxSize,
          children = _this$props6.children,
          onClick = _this$props6.onClick,
          onChange = _this$props6.onChange,
          onFileDialogCancel = _this$props6.onFileDialogCancel,
          fluid = _this$props6.fluid,
          onDragEnter = _this$props6.onDragEnter,
          onDragLeave = _this$props6.onDragLeave,
          onDragStart = _this$props6.onDragStart,
          onDragOver = _this$props6.onDragOver,
          onDrop = _this$props6.onDrop,
          rest = _objectWithoutProperties(_this$props6, ["as", "name", "className", "wrapperRef", "innerRef", "accept", "multiple", "minSize", "maxSize", "children", "onClick", "onChange", "onFileDialogCancel", "fluid", "onDragEnter", "onDragLeave", "onDragStart", "onDragOver", "onDrop"]);

      var disabled = rest.disabled;
      var _this$state = this.state,
          active = _this$state.active,
          files = _this$state.files,
          accepted = _this$state.accepted,
          rejected = _this$state.rejected;
      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames();
      var ref = wrapperRef || this.wrapperRef;
      var inputRef = innerRef || this.innerRef;
      var context = {
        active: active,
        disabled: disabled,
        ref: ref,
        files: files,
        accepted: accepted,
        rejected: rejected,
        open: this.open,
        onClick: this.handleOnClick,
        onDragStart: this.handleOnDragStart,
        onDragEnter: this.handleOnDragEnter,
        onDragOver: this.handleOnDragOver,
        onDragLeave: this.handleOnDragLeave,
        onDrop: this.handleOnDrop
      };
      return _react.default.createElement(Wrapper, _extends({}, rest, {
        className: classNames
      }), _react.default.createElement("input", {
        ref: inputRef,
        type: "file",
        name: name,
        accept: (0, _lib.arrayHasItems)(accept) ? accept.join(',') : accept,
        multiple: multiple,
        onChange: this.handleOnChange,
        autoComplete: "off",
        disabled: disabled
      }), _react.default.createElement(_context5.default.Provider, {
        value: context
      }, (0, _lib.getRenderProps)(children, context)));
    }
  }]);

  return FileInput;
}(_react.PureComponent);

exports.default = FileInput;

_defineProperty(FileInput, "className", 'MHub-FileInput');

_defineProperty(FileInput, "DropZone", _DropZone.default);

_defineProperty(FileInput, "Consumer", _context5.default.Consumer);

_defineProperty(FileInput, "displayName", 'FileInput');

_defineProperty(FileInput, "propTypes", {
  children: _common.customPropTypes.render,
  as: _common.customPropTypes.as,
  className: _propTypes.default.string,
  name: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  fluid: _propTypes.default.bool,
  // file
  accept: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  blob: _propTypes.default.oneOfType([_propTypes.default.oneOf(_constants.BLOB_TYPES), _propTypes.default.arrayOf(_propTypes.default.oneOf(_constants.BLOB_TYPES))]),
  multiple: _propTypes.default.bool,
  minSize: _propTypes.default.number,
  maxSize: _propTypes.default.number,
  // ref
  wrapperRef: _common.customPropTypes.ref,
  innerRef: _common.customPropTypes.ref,
  // drag drop
  onError: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onFileDialogCancel: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onDragStart: _propTypes.default.func,
  onDragEnter: _propTypes.default.func,
  onDragOver: _propTypes.default.func,
  onDragLeave: _propTypes.default.func,
  onDrop: _propTypes.default.func
});

_defineProperty(FileInput, "defaultProps", {
  children: null,
  as: null,
  className: null,
  name: null,
  disabled: false,
  fluid: false,
  accept: null,
  blob: null,
  multiple: false,
  minSize: 0,
  maxSize: Infinity,
  // ref
  wrapperRef: null,
  innerRef: null,
  // drag drop
  onChange: null,
  onError: null,
  onFileDialogCancel: null,
  onClick: null,
  onDragStart: null,
  onDragEnter: null,
  onDragOver: null,
  onDragLeave: null,
  onDrop: null
});

_defineProperty(FileInput, "readFile", function (file, blob) {
  switch (blob) {
    case 'arrayBuffer':
      return FileInput.readAsArrayBuffer(file);

    case 'binaryString':
      return FileInput.readAsBinaryString(file);

    case 'dataURL':
      return FileInput.readAsDataURL(file);

    case 'text':
      return FileInput.readAsText(file);

    default:
      return null;
  }
});

_defineProperty(FileInput, "readAsArrayBuffer", function (file) {
  if (window.FileReader && file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();

      reader.onloadend = function () {
        var result = reader.result,
            error = reader.error;
        if (error) reject(error);
        resolve(result);
      };

      reader.readAsArrayBuffer(file);
    });
  }

  return null;
});

_defineProperty(FileInput, "readAsBinaryString", function (file) {
  if (window.FileReader && file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();

      reader.onloadend = function () {
        var result = reader.result,
            error = reader.error;
        if (error) reject(error);
        resolve(result);
      };

      reader.readAsBinaryString(file);
    });
  }

  return null;
});

_defineProperty(FileInput, "readAsDataURL", function (file) {
  if (window.FileReader && file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();

      reader.onloadend = function () {
        var result = reader.result,
            error = reader.error;
        if (error) reject(error);
        resolve(result);
      };

      reader.readAsDataURL(file);
    });
  }

  return null;
});

_defineProperty(FileInput, "readAsText", function (file) {
  if (window.FileReader && file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();

      reader.onloadend = function () {
        var result = reader.result,
            error = reader.error;
        if (error) reject(error);
        resolve(result);
      };

      reader.readAsText(file);
    });
  }

  return null;
});